import React, { useCallback } from 'react';
import logo from '../../assets/images/logo.png';
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Media,
  Nav,
  Navbar,
  UncontrolledDropdown
} from 'reactstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../store/slices/authSlice';
import '../../assets/styles/header.css';
import { externalLoginService } from '../../services';
import { getLoggedInUser } from '../../helpers/common';

function Header() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const sidebarToggle = () => {
    document.body.classList.toggle('sidebar-toggle');
  };

  const handleLogout = useCallback(async () => {
    const logoutResponse = await externalLoginService.externalLogout();
    if (logoutResponse?.data?.isSuccess) {
      dispatch(logout());
      setTimeout(() => {
        navigate('/ExternalLogin')
      }, 1000);
    }
  }, [])

  return (
    <header className="navbar navbar-dark sticky-top flex-md-nowrap p-0 shadow">
      <NavLink className="navbar-brand hide-sidebar me-0 p-0 py-0 fs-7 text-center" to="dashboard">
        <img
          className="light"
          alt="ITC"
          src={logo}
          width="50"
        />
        <img
          className="dark"
          alt="ITC"
          src={logo}
          width="50"
        />
      </NavLink>
      <Button className="light"
        onClick={sidebarToggle}
        style={{ paddingLeft: '20px' }}
      >
        <i className='bx bx-menu'></i>
      </Button >
      <Button className="dark"
        onClick={sidebarToggle}
        style={{ marginRight: 'auto', paddingLeft: '20px' }}
      >
        <i className='bx bx-menu'></i>
      </Button>
      <Button
        className="navbar-toggler position-absolute d-md-none collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#sidebarMenu"
        aria-controls="sidebarMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </Button>
      <Navbar className="navbar-nav p-0">
        <Nav
          className="align-items-center justify-content-end  d-md-flex"
          navbar
        >
          <UncontrolledDropdown nav>
            <DropdownToggle className="pr-0 bg-transparent border-0" >
              <Media className="align-items-center d-flex">
                <Media className="d-lg-block">
                  Hello, <span className="mb-0 text-sm font-weight-bold text-white">
                    {getLoggedInUser().Name}
                  </span>
                </Media>
                <span className="avatar avatar-sm rounded-circle border">
                  <img
                    alt="user"
                    src={require('../../assets/images/user.png')}
                    width="48"
                    className="rounded-circle me-2"
                  />
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow">
              <button className="border-0 bg-transparent dropdown-item py-0" onClick={() => navigate("/External/profile")}>
                <i className='bx bxs-user-detail'></i>
                <span>My profile</span>
              </button>
              <DropdownItem divider />
              <button className="border-0 bg-transparent dropdown-item py-0" onClick={handleLogout}>
                <i className='bx bx-log-out'></i>
                <span>Logout</span>
              </button>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
      </Navbar>
    </header>
  );
}

export default Header;
